import type { ReactNode } from 'react';
import { AlertCircle, CheckCircle2, Clock, Info, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

export function WarehouseFieldStatus({ label, message, tone = 'idle', children }: {
  label: string; message: string; tone?: 'idle' | 'saving' | 'success' | 'warning' | 'error'; children?: ReactNode;
}) {
  const Icon = tone === 'saving' ? Loader2 : tone === 'success' ? CheckCircle2
    : tone === 'error' ? AlertCircle : tone === 'warning' ? Clock : Info;
  return (
    <>
      <span role="status" className="sr-only">{message}</span>
      <Popover>
        <PopoverTrigger asChild>
          <Button type="button" variant="ghost" size="icon" aria-label={label} title={message}
            className={cn('h-6 w-6 shrink-0 p-0',
              tone === 'success' ? 'text-success' : tone === 'error' ? 'text-destructive'
                : tone === 'warning' ? 'text-warning' : 'text-muted-foreground')}>
            <Icon aria-hidden="true" className={cn('h-3.5 w-3.5', tone === 'saving' && 'animate-spin')} />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" aria-label={label} className="space-y-3 p-3 text-xs" onClick={event => event.stopPropagation()}>
          <p className="whitespace-pre-line break-words">{message}</p>
          {children}
        </PopoverContent>
      </Popover>
    </>
  );
}
